module.exports = "<div class=\"igo-bookmark-button-container\">\r\n  <button\r\n    mat-icon-button\r\n    [matTooltip]=\"'igo.bookmarkButton.create' | translate\"\r\n    matTooltipPosition=\"above\"\r\n    [color]=\"color\"\r\n    (click)=\"createContext()\">\r\n    <mat-icon>\r\n      bookmark\r\n    </mat-icon>\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/map/bookmark-button/bookmark-button.component.html
// module id = 901
// module chunks = 0